import styled from 'styled-components';
import { theme } from '@upsolve/ui';
import LinkCSS from '../Links/A.css';

const Article = styled.div`
  width: 100%;
  max-width: 920px;
  margin: 2em auto;
  display: flex;
  flex-direction: column;
  overflow: visible;

  .article__breadcrumb {
    margin: 0 0 0.25em;
    ol {
      list-style-type: none;
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      li {
        margin-right: 4px;
        color: ${props => props.theme.colors.white['100']};
        a, a:hover {
          color: ${props => props.theme.colors.white['100']};
        }
      }
      li:not(:first-child):before {
        content: "/";
        margin-right: 4px;
        opacity: 0.35;
      }
    }
    @media(max-width: 65em) {
      margin: 0 0 0.25em;
    }
  }

  .article__content {
    word-break: break-word;

    div.cover-image {
      height: 300px;
      width: 100%;
      margin: 0 auto 2em;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .content-hero {
      display: flex;
      flex-direction: row;
      align-items: space-between;
      min-height: 200px;
      margin: 0 -4em 3em 0;
      width: calc(100% + 4em);
      @media(max-width: 65em) {
        margin: 2em 0 3em;
        width: 100%;
      }
      @media(max-width: 45em) {
        flex-direction: column;
        align-items: initial;
      }
    }
    .content-hero__header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      padding-bottom: 2em;
      ol, ul {
        padding: 0;
        margin: 0.5em 0;
      }
      label {
        margin-right: 0.5em;
      }
      h1 {
        background: ${props => props.theme.colors.white['900']};
        padding: 0.25em 1em 0.25em 0.25em;
        margin: 0 -0.25em;
      }
      @media(max-width: 45em) {
        padding-bottom: 5em;
      }
    }
    .content-hero__cta {
    }

    .content-author {
      display: flex;
      align-items: center;
      background: ${props => props.theme.colors.white['900']};
      padding: 0.1em 0.5em;
      margin: -0.1em -0.5em;
      & > div {
        margin: 1.25em 0;
      }
      .author-image, img {
        height: 48px;
        width: 48px;
        min-height: 48px;
        min-width: 48px;
        border-radius: 36px;
      }
      p {
        margin: 1em 0.75em;
      }
      small {
        color: ${props => props.theme.colors.gray['900']};
      }
    }
    .content-insert {
      a {
        ${LinkCSS}
      }
    }

    .content-video {
      width: 640px;
      max-width: 100%;
      height: 360px;
      margin: 0 auto;
      padding: 1em 0;
      @media (max-width: 45em) {
        width: 540px;
        height: 270px;
      }
    }

    .content-body {
      width: 75%;
      max-width: 640px;
      float: left;
      padding: 0;
      margin-top: 0.5em;
      &.full-width {
        width: 100%;
        max-width: 100%;
      }
      section, div.section {
        display: block;
        padding-bottom: 2em;
        margin-bottom: 2em;
        border-bottom: 1px solid ${props => props.theme.colors.white['500']};
        &:first-of-type {
          & > *:first-of-type {
            margin-top: 0;
          }
        }
        &:last-of-type {
          border-bottom: none;
        }
        p {
          img {
            min-height: 240px;
            min-width: 240px;
            height: auto;
            width: auto;
            max-height: 400px;
            max-width: 100%;
            display: block;
            margin: 0 auto;
          }
        }
        img {
          max-height: 360px;
          margin: 0 auto;
          max-width: 100%;
        }
        @media(max-width: 45em) {
          padding-bottom: 1.5em;
          margin-bottom: 1.5em;
        }
      }
      @media(max-width: 45em) {
        padding: 1em 0;
        width: 100%;
      }
    }

    .content-body__lead {
      width: 100%;
      & > div, & > section, & > div.section {
        width: 100%;
      }
      .summary {
        padding: 0 0 1em;
        margin: 0 auto 2em;
        border: 2px solid ${props => props.theme.colors.white['500']};
        background: ${props => props.theme.colors.white['900']};
        b {
          font-size: 18px;
          font-weight: 500;
          background: ${props => props.theme.colors.white['900']};
          padding: 0.25em 1em;
          margin: 0 1em;
          position: relative;
          top: -0.8em;
        }
        p {
          padding: 0 2em;
          margin: 1em 0 1.5em;
        }
      }
    }

    .content-body__nav {
      list-style-type: disc;
      color: ${props => props.theme.colors.white['300']};
      li {
        margin-left: 0;
        padding-left: 0;
        & > a {
          color: ${props => props.theme.colors.brand['500']};
        }
      }
    }
    ul {
      list-style-type: disc;
    }
    ul, ol {
      padding: 0 1em 0.25em 1em;
    }
    li {
      margin: 0 .25em .5em;
    }
    hr {
      margin: 1em 0;
      border: 1px solid ${props => props.theme.colors.white['700']};
    }
    h1 {
      margin: 0;
    }
    h2, h3, h4, h5, h6 {
      margin: 1em 0 0.25em;
      line-height: 125%;
    }
    iframe {
      border: none;
      outline: none;
      max-width: 100%;
    }
    p, li {
      a {
        ${LinkCSS}
      }
    }
    table {
      margin: 0.75em 0;
    }
    small.back-to-top {
      margin-top: 0.5em;
      font-size: 12px;
      & > a {
        color: ${props => props.theme.colors.gray['900']};
      }
    }
  }

  aside {
    float: right;
    width: 220px;
    color: ${props => props.theme.colors.gray['500']};
    h5 {
      border-bottom: 1px solid ${props => props.theme.colors.white['500']};
    }
    & > div, & > section, & > div.section {
      display: flex;
      flex-direction: column;
      margin-bottom: 2em;
    }
    p, li > a {
      font-size: 14px;
    }
    p > a {
      ${LinkCSS}
    }
    ul {
      margin-top: 1em;
      list-style: disc;
      color: ${props => props.theme.colors.white['500']};
      li {
        margin-left: 1em;
        margin-bottom: 0.1em;
        & > a {
          color: ${props => props.theme.colors.brand['500']};
        }
      }
    }
    @media(max-width: 45em) {
      width: 100%;
      margin: 3em 0;
      opacity: 1;
    }
  }

  @media(max-width: 45em) {
    .article__breadcrumb {
      margin: 0 1.75em;
      ol {
        margin: 0;
        font-size: 14px;
      }
    }
    .article__body {
      margin: 1em 1.5em;
    }
  }
`;

export default Article;
